import FundMedia from './FundMedia'

export default FundMedia
